import { render } from "./EventNotificationList.vue?vue&type=template&id=086007d8"
import script from "./EventNotificationList.vue?vue&type=script&lang=js"
export * from "./EventNotificationList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__